import { testimonials } from "@/mocks/testimonials";
import SectionHeading from "@/components/feature/SectionHeading";

export default function TestimonialSection() {
  return (
    <section className="bg-background-50 py-12 md:py-16" aria-label="读者口碑">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="读者口碑"
          title="大家都在叮咚追更"
          desc="来自读者们的真实评价，是叮咚漫画网不断前进的最大动力。"
          align="center"
        />
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="flex flex-col rounded-xl bg-background-100 border border-background-200 p-5"
            >
              <div className="flex gap-0.5 text-secondary-500" aria-label="五星评价">
                {[0, 1, 2, 3, 4].map((i) => (
                  <i key={i} className="ri-star-fill text-sm" />
                ))}
              </div>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                “{t.content}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={`${t.name} 用户头像`}
                  title={`${t.name} 口碑评价`}
                  className="h-10 w-10 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}